import { Box } from '@chakra-ui/react';
import _ from 'lodash';
import PrivateChannelArticleShortCard from 'presentation/components/modules/community/privateChannel/PrivateChannelArticleShortCard';
import Carousel from 'presentation/components/shared/Carousel/Carousel';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppRoute from 'router/AppRoute';
import { useFetchPrivateChannelArticlesQuery } from 'rtkQuery/sharespro/queries/articles';

const CommunityPrivateChannelCardsRowContainer: FC = () => {
  const { data } = useFetchPrivateChannelArticlesQuery({ page: 1 });
  const { data: data2 } = useFetchPrivateChannelArticlesQuery({ page: 2 });

  const { t } = useTranslation();

  if (!data || data.items.length === 0) return null;
  const dataItems = data2 && data.items.length > 0 ? [...data.items, ...data2.items] : null;
  const articles = _.take(dataItems ?? data.items, 50);

  return (
    <Box mb="20px">
      <GridHeading
        trailingLink={{
          text: t('allItems'),
          path: AppRoute.privateChannel,
        }}
      >
        {t('privateChannel')}
      </GridHeading>
      <Carousel
        scrollBy={352}
        itemsCount={articles.length}
        viewportItemsCount={2}
        showControls={articles.length > 2}
        scrollType="fixed"
      >
        {articles.map((article, index) => {
          return (
            <Box key={article.id} mr={index < articles.length - 1 ? '15px' : '0'}>
              <PrivateChannelArticleShortCard article={article}/>
            </Box>
          );
        })}
      </Carousel>
    </Box>
  );
};

export default CommunityPrivateChannelCardsRowContainer;
